import { useQuery } from "@tanstack/react-query";
import { getTaskQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import { getTask } from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";
import { createPreviousOnNullPlaceholderDataFn } from "@coworker/apprestructured/src/task-management/services/queryHelper";

export function useTask(id: string | null) {
  return useQuery({
    queryKey: getTaskQueryKey(id),
    queryFn: () => getTask(id!),
    enabled: id !== null,
    placeholderData: createPreviousOnNullPlaceholderDataFn<Task>(id),
  });
}
